import { useState, useRef } from 'react';
import { toggleDemoTier, getDemoTier } from '../lib/cerebro';

/**
 * DemoToggle — Triple-click on logo to toggle between tiers
 * For demos with Progresion: shows how analysis changes per tier
 *
 * Usage: Wrap the logo or any element with this component
 * <DemoToggle><img src={logo} /></DemoToggle>
 */
export default function DemoToggle({ children }) {
  const [tier, setTier] = useState(getDemoTier());
  const [showToast, setShowToast] = useState(false);
  const clickCount = useRef(0);
  const clickTimer = useRef(null);

  const handleClick = () => {
    clickCount.current += 1;

    if (clickCount.current === 3) {
      clickCount.current = 0;
      clearTimeout(clickTimer.current);

      const newTier = toggleDemoTier();
      setTier(newTier);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2500);

      // Force reload components that depend on tier
      window.dispatchEvent(new CustomEvent('demo-tier-changed', { detail: newTier }));
    } else {
      clearTimeout(clickTimer.current);
      clickTimer.current = setTimeout(() => {
        clickCount.current = 0;
      }, 500);
    }
  };

  const tierInfo = {
    basic: { label: 'BÁSICO ($0-$1K)', color: '#6B7280', bg: '#F9FAFB' },
    intermediate: { label: 'INTERMEDIO ($1K-$10K)', color: '#F59E0B', bg: '#FFFBEB' },
    advanced: { label: 'AVANZADO ($10K-$50K)', color: '#7C3AED', bg: '#F5F3FF' },
    premium: { label: 'PREMIUM ($50K+)', color: '#DC2626', bg: '#FEF2F2' },
  };

  return (
    <div className="relative">
      <div onClick={handleClick} className="cursor-pointer">
        {children}
      </div>

      {/* Demo mode indicator */}
      {tier && (
        <div
          className="absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-white"
          style={{ backgroundColor: tierInfo[tier]?.color || '#6B7280' }}
        />
      )}

      {/* Toast notification */}
      {showToast && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] animate-fade-in">
          <div
            className="px-4 py-2.5 rounded-xl shadow-lg border text-xs font-semibold"
            style={{
              backgroundColor: tier ? tierInfo[tier]?.bg : '#F0FDF4',
              borderColor: tier ? tierInfo[tier]?.color + '30' : '#BBF7D0',
              color: tier ? tierInfo[tier]?.color : '#059669',
            }}
          >
            {tier
              ? `Demo: ${tierInfo[tier].label}`
              : 'Demo desactivado (tier real)'}
          </div>
        </div>
      )}
    </div>
  );
}
